import TransportElementTerminal from './transport_element_terminal';

export default TransportElementTerminal;
